import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import Loading from '../_library/Loading'
import Chart from 'react-apexcharts'
import { chain } from 'lodash'
import { Box } from '@mui/material'
import { useFirestore } from '../../hooks/useFirestore'
import { PB_LESSON_COLLECTION } from '../../_constants/globals'


export const InstructorsGraph = ({ progressBookId, sx }) => {
  
  const lessonHooks = useFirestore(PB_LESSON_COLLECTION)
  const dbLessons = lessonHooks.getDocs()
  
  const lessons = useMemo(() => dbLessons?.filter(l => l.progressBookRef.id === progressBookId), [dbLessons, progressBookId])

  const data = useMemo(() =>
    chain(lessons)
      .groupBy(l => l.instructor?.firstname + ' ' + l.instructor?.lastname)
      .mapValues((arr, index) => ({ instructor: index, length: arr.length }))
      .values()
      .orderBy('length', 'desc')
      .value()
  , [lessons])

  const series = data.map(val => val.length)
  const options = {
    labels: data.map(val => val.instructor),
    chart: {
      width: 380,
      type: 'pie',
    },
    responsive: [{
      breakpoint: 480,
      options: {
        chart: {
          width: 200,
        },
        legend: {
          position: 'bottom',
        },
      },
    }],
  }

  if (!data) return <Loading />
  else return (
    <Box sx={{ width: '100%', height: 200, ...sx }}>
      <Chart options={options} series={series} type='pie' width={380} />
    </Box>
  )
}

InstructorsGraph.propTypes = {
  progressBookId: PropTypes.string.isRequired,
  sx: PropTypes.object,
}

export default InstructorsGraph
